module.exports = __webpack_public_path__ + "img/Frame 4.aae172bd.png";